export default __webpack_public_path__ + "static/media/its_a_tie.62e71e62.mp3";